import { Check } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { Habit } from '@/src/renderer/lib/db/models'
import type { HabitDayState } from '../../lib/habitDay'
import type { StreakResult } from '../../lib/streak'
import { habitTimeSlot } from '../../lib/habitsContent'
import { HabitStreakBadge } from '../HabitStreakBadge'
import './HabitRow.scss'

interface HabitRowProps {
  habit: Habit
  dayState: HabitDayState
  streak: StreakResult
  /** Future day → read-only preview, not toggleable. */
  disabled?: boolean
  onToggle: () => void
}

export function HabitRow({ habit, dayState, streak, disabled, onToggle }: HabitRowProps) {
  const { t } = useTranslation()
  const slot = habitTimeSlot(habit)
  return (
    <div className={`habit-row ${dayState.completed ? 'habit-row--done' : ''} ${disabled ? 'habit-row--readonly' : ''}`}>
      <button
        type="button"
        className="habit-row__check"
        role="checkbox"
        aria-checked={dayState.completed}
        aria-label={habit.title}
        disabled={disabled}
        onClick={onToggle}
      >
        {dayState.completed && <Check size={13} strokeWidth={3} aria-hidden />}
      </button>

      {slot !== 'anytime' && <span className={`habit-row__slot habit-row__slot--${slot}`} aria-hidden />}

      <span className="habit-row__label">{habit.title}</span>

      {dayState.isFlexible && (
        <span className="habit-row__quota">
          {dayState.quotaMet
            ? t('habits.quota.doneWeek')
            : t('habits.quota.week', { done: dayState.quotaDone, total: dayState.quotaTotal })}
        </span>
      )}

      <span className="habit-row__spacer" />

      <HabitStreakBadge current={streak.current} state={streak.state} />
    </div>
  )
}
